import ApiRoutes from "../../../../constants/api-routes";
import { hneAdminApi } from "../../../../service";

export const sendFeedback = async (body) =>
  hneAdminApi.post(`${ApiRoutes.SEND_FEEDBACK}`, body);
